import React, { useMemo } from "react";
import { useChatContext } from "../../../contexts/ChatContext";
import { useSidebarContext } from "../../../contexts/SidebarContext";
import { useVesselContext } from "../../../contexts/VesselContext";
import { useMapDisplayContext } from "../../../contexts/MapDisplayContext";
import { useWarningZoneContext } from "../../../contexts/WarningZoneContext";
import styles from "./ChatMessage.module.css";
import Btn from "../../Btn/Btn";
import LeftArrowIcon from "../../Icons/LeftArrowIcon";
import { useAppContext } from "../../../contexts/AppContext";
const WarningZoneChatMessage: React.FC = () => {
    const { warningZoneMessage } = useChatContext();
    const { chosenWarningZoneId, setContentType, setChosenWarningZoneId } = useSidebarContext();
    const { vessels } = useVesselContext();
    const { action } = useMapDisplayContext();
    const { warningZones } = useWarningZoneContext();
    const { showDialog } = useAppContext();
    const messages = useMemo(() => {
        if (!chosenWarningZoneId) return [];
        return warningZoneMessage[chosenWarningZoneId] ?? [];
    }, [warningZoneMessage, chosenWarningZoneId]);

    if (!chosenWarningZoneId) return null;

    return (
        <>
            <div className={" text w-100 pe-2 ps-2 pt-2 pb-0"}>
                <div className="d-flex align-items-center mb-2">
                    <Btn
                        className={styles["left-btn"] + " text back-to-chats-list-btn"}
                        title="Quay lại"
                        onClick={() => {
                            setChosenWarningZoneId("");
                            setContentType("warningZoneList");
                        }}
                    >
                        <LeftArrowIcon />
                    </Btn>
                    <div className="flex-grow-1 text-center fw-bold">{warningZones[chosenWarningZoneId]?.name}</div>
                </div>
            </div>

            <div className={styles["chat-messages"] + " styled-scrollbar"}>
                {messages.length == 0 && (
                    <div className="text-center text-muted">Chưa có tin nhắn nào cho vùng này</div>
                )}

                {messages.map((m: any) => {
                    const time = new Date(m.sentTime ?? (m.sentTime == 0 ? m.sentTime : Date.now()));
                    return (
                        <div
                            key={m.sentTime + (m.zoneId ?? "")}
                            className={styles["message-container"] + " " + styles["message-container-sent"]}
                        >
                            <div className={styles["message-sent"] + " text position-relative"}>
                                {m.message}
                            </div>
                            <div className={"text-small " + styles["message-timestamp"]}>
                                {time.toLocaleString()+" "}
                                {Array.isArray(m.unitIds) && m.unitIds.length > 0 && (() => {
                                    const recipients = m.unitIds.map((uid: string) => {
                                        const name = vessels[uid]?.vesselName ?? uid;
                                        return name != uid ? `${name}` : uid;
                                    }).join(', ');
                                    return (
                                        <span
                                            title={recipients}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                showDialog("Danh sách tàu nhận tin nhắn", recipients, "info");
                                            }}
                                        >
                                            Đã gửi tới ({m.unitIds.length})
                                        </span>
                                    );
                                })()}
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    );
};

export default WarningZoneChatMessage;
